export default __webpack_public_path__ + "static/media/unread-checkbox.481eef52.svg";